import React, { useEffect, useRef } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { getImageSrc } from '../../../../../helpers/getImageSrc'
import { useCheckVersion } from '../../../../../hooks/useCheckVersion'
import { PaginationStoreType } from '../../../../../stores/NewPaginationStore'
import requestsManagementStore from '../../../../../stores/RequestsManagementStore'
import RequestFilterChip from '../../NewRequestFilters/components/RequestFilterChip'
import { RequestsTableFilterStoreType } from '../stores/RequestsTableFilterStore'
import { RequestTableParamsType } from '../types/new-requests-table.types'
import { useRequestsTableData } from './useNewRequestsTableData'

export const useRequestsTableFilters = (
  paginationStore: PaginationStoreType<RequestTableParamsType>,
  filtersStore: RequestsTableFilterStoreType,
) => {
  const intl = useIntl()
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  const { checkVersion } = useCheckVersion()
  const { openAddRequestDrawer } = requestsManagementStore
  const { getParams, setSelectedFilters } = filtersStore
  const { data } = useRequestsTableData(paginationStore)
  const { setParams, setPage } = paginationStore

  useEffect(() => {
    return () => {
      timeoutRef.current && clearTimeout(timeoutRef.current)
    }
  }, [])

  const onSearch = () => {
    const params = getParams()
    setSelectedFilters()
    setPage(0)

    return Promise.resolve(setParams(params, ['preset.statuses']))
  }

  const handleDeleteChip = (propName: string, multiselectValue: any) => {
    filtersStore.deleteFilter(propName, multiselectValue)

    if (propName === 'territory') {
      filtersStore.deleteFilter('district', multiselectValue)
      filtersStore.deleteFilter('locality', multiselectValue)
    } else if (propName === 'district') {
      filtersStore.deleteFilter('locality', multiselectValue)
    }

    timeoutRef.current && clearTimeout(timeoutRef.current)
    timeoutRef.current = setTimeout(() => {
      onSearch()
    }, 0)
  }

  const setChip = (params: any, withAction: any) => (
    <RequestFilterChip {...params} onClick={withAction && handleDeleteChip} />
  )

  const adminButtonProps = {
    name: <FormattedMessage id={'Создать заявку'} />,
    onClick: async () => {
      const isAvailable = await checkVersion()
      isAvailable && openAddRequestDrawer?.()
    },
    icon: getImageSrc('new-request'),
  }

  const getActionButtonProps = () => {
    return adminButtonProps
  }

  return {
    setChip,
    intl,
    data,
    onSearch,
    actionButtonProps: getActionButtonProps(),
  }
}
